export enum ACTIVITY_TRANSACTION_TYPE {
  Mint = 'list',
  Transfer = 'transfer_nft',
  ForSale = 'sell',
  Bought = 'buy',
  Withdraw = 'withdraw_nft',
  Lock = 'lock',
  Auction = 'auction',
}

export enum ACTIVITY_COLUMNS_ID {
  TransactionType = 'transaction_type',
  Item = 'item',
  Type = 'type',
  Price = 'price',
  Quantity = 'quantity',
  From = 'from',
  To = 'to',
  Time = 'time',
}

export const ACTIVITY_COLUMNS = [
  { id: ACTIVITY_COLUMNS_ID.TransactionType, title: 'Type' },
  { id: ACTIVITY_COLUMNS_ID.Item, title: 'Item' },
  { id: ACTIVITY_COLUMNS_ID.Type, title: 'Type' },
  { id: ACTIVITY_COLUMNS_ID.Price, title: 'Price' },
  { id: ACTIVITY_COLUMNS_ID.Quantity, title: 'Quantity' },
  { id: ACTIVITY_COLUMNS_ID.From, title: 'From' },
  { id: ACTIVITY_COLUMNS_ID.To, title: 'To' },
  { id: ACTIVITY_COLUMNS_ID.Time, title: 'Time' },
];

export const ACTIVITY_LIST_TYPE_TRANSACTION = [
  { key: ACTIVITY_TRANSACTION_TYPE.Mint, title: 'Mint' },
  { key: ACTIVITY_TRANSACTION_TYPE.Withdraw, title: 'Withdraw' },
  { key: ACTIVITY_TRANSACTION_TYPE.Transfer, title: 'Transfer' },
  { key: ACTIVITY_TRANSACTION_TYPE.ForSale, title: 'For sale' },
  { key: ACTIVITY_TRANSACTION_TYPE.Bought, title: 'Bought' },
];
